import { render, staticRenderFns } from "./LeafFall.vue?vue&type=template&id=6c169b30&scoped=true&"
var script = {}
import style0 from "./LeafFall.vue?vue&type=style&index=0&id=6c169b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c169b30",
  null
  
)

export default component.exports